/* import __COLOCATED_TEMPLATE__ from './x-phone-input.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import { PREFERRED_COUNTRIES } from 'register-partners-js/constants/countries';

import styles from './x-phone-input.module.css';

export default class XPhoneInput extends Component {
  styles = styles;

  @tracked isValidNumber;

  preferredCountry = PREFERRED_COUNTRIES[0];
  preferredCountries = PREFERRED_COUNTRIES;

  get autovalidate() {
    return this.args.autovalidate ?? true;
  }

  @action
  handleKeyPress(e) {
    // prevent letters and `+` to be input
    // but allow `ctrl+a`
    let character = e.key;

    let isLetterOrPlus = character && character.match(/[a-z+]/i);
    let isCtrlPressed = e.ctrlKey;
    let isMetaPressed = e.metaKey;
    let isBackSpace = character === 'Backspace';
    let isTab = character === 'Tab';
    let isEnter = character === 'Enter';

    if (isLetterOrPlus && !isCtrlPressed && !isMetaPressed && !isBackSpace && !isTab && !isEnter) {
      e.preventDefault();
      return false;
    }
  }

  @action
  handleUpdate(number, { isValidNumber }) {
    this.isValidNumber = this.numberIsObscured(number) || isValidNumber;

    return this.args.update(number, { isValidNumber: this.isValidNumber });
  }

  numberIsObscured(str) {
    return (str || '').toLowerCase().includes('x');
  }
}
